import { maskVisitorDisplayNameIfNeeded } from "../../../../utils/utils";
import _ from "lodash";

export default {
    methods: {
        maskVisitorDisplayName(val) {
            return maskVisitorDisplayNameIfNeeded(val, _.get(this.activity, "refVisitor"));
        },
    },
};
